/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Degree_TypeInputs */

const en_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Degree Type`)
};

const de_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschlussart`)
};

const fr_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de diplome`)
};

const es_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de titulo`)
};

const it_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di laurea`)
};

const nl_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type diploma`)
};

const pl_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodzaj dyplomu`)
};

const fi_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutkinnon tyyppi`)
};

const da_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksamentype`)
};

const sv_resume_editor_degree_type = /** @type {(inputs: Resume_Editor_Degree_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examenstyp`)
};

/**
* | output |
* | --- |
* | "Degree Type" |
*
* @param {Resume_Editor_Degree_TypeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_degree_type = /** @type {((inputs?: Resume_Editor_Degree_TypeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Degree_TypeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_degree_type(inputs)
	if (locale === "fr") return fr_resume_editor_degree_type(inputs)
	if (locale === "es") return es_resume_editor_degree_type(inputs)
	if (locale === "it") return it_resume_editor_degree_type(inputs)
	if (locale === "nl") return nl_resume_editor_degree_type(inputs)
	if (locale === "pl") return pl_resume_editor_degree_type(inputs)
	if (locale === "fi") return fi_resume_editor_degree_type(inputs)
	if (locale === "da") return da_resume_editor_degree_type(inputs)
	if (locale === "sv") return sv_resume_editor_degree_type(inputs)
	return en_resume_editor_degree_type(inputs)
});